
export const storeCurrency = (val) => {
  localStorage.setItem('currency', val);
}

export const getCurrency = localStorage.getItem('currency') || "ch"
